/* Aplicar cupom no carrinho ao clicar (botoes com data-nv-apply-discount).
 * - Mostra a mensagem na hora do clique (aviso proprio, nao depende de outro script).
 * - Aplica pelo caminho nativo da Shopify (/discount/CODIGO), sem sair da pagina.
 * - Mantem os cupons que ja estavam no carrinho e soma o novo.
 * Usado pelo banner de campanha (sections/nv-hero.liquid). */
(function () {
  'use strict';
  if (window.__nvApplyDiscount) return;
  window.__nvApplyDiscount = true;

  var toastT;
  function toast(title, text) {
    var el = document.getElementById('nv-cupom-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'nv-cupom-toast';
      el.className = 'nv-cupom-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML = '<strong class="nv-cupom-toast__title"></strong><span class="nv-cupom-toast__text"></span>';
      document.body.appendChild(el);
    }
    el.querySelector('.nv-cupom-toast__title').textContent = title;
    el.querySelector('.nv-cupom-toast__text').textContent = text || '';
    el.classList.remove('is-show');
    void el.offsetWidth;
    el.classList.add('is-show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-show'); }, 4500);
  }

  function marcar(code) {
    document.querySelectorAll('[data-nv-apply-discount]').forEach(function (b) {
      if ((b.getAttribute('data-code') || '').toUpperCase() !== code.toUpperCase()) return;
      b.classList.add('nv-applied');
      var lbl = b.getAttribute('data-applied-label');
      if (lbl && b.classList.contains('nv-hero-cta')) b.textContent = lbl;
    });
  }

  function codigosAtuais(cart) {
    var list = (cart && cart.discount_codes) || [];
    return list.map(function (d) { return d.code; }).filter(Boolean);
  }

  function aplicarNoServidor(code) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    /* 1) caminho nativo: grava o cupom no carrinho/checkout */
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', opts)
      .catch(function () {})
      .then(function () {
        /* 2) garante a soma com cupons que ja estavam no carrinho */
        return fetch('/cart.js', opts).then(function (r) { return r.json(); }).then(function (cart) {
          var codes = codigosAtuais(cart);
          var tem = codes.some(function (c) { return c.toUpperCase() === code.toUpperCase(); });
          if (tem) return;
          codes.push(code);
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          });
        });
      })
      .catch(function () {})
      .then(function () {
        if (window.NV && typeof window.NV.refreshCart === 'function') {
          try { window.NV.refreshCart(); } catch (e) {}
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nv-apply-discount]');
    if (!btn) return;
    e.preventDefault();
    var code = (btn.getAttribute('data-code') || '').trim();
    if (!code) return;
    var msg = btn.getAttribute('data-success') || ('Cupom ' + code + ' aplicado no carrinho.');
    var partes = msg.split('! ');
    if (partes.length > 1) toast(partes.shift() + '!', partes.join('! '));
    else toast(msg, '');
    marcar(code);
    if (btn._nvBusy) return;
    btn._nvBusy = true;
    aplicarNoServidor(code).then(function () { btn._nvBusy = false; });
  });

  function init() {
    if (!document.querySelector('[data-nv-apply-discount]')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { codigosAtuais(cart).forEach(marcar); })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
